import { normalizeApiErrorBody } from "./apiErrorBody";
import { buildTypePermissionSettingsPath } from "./typeSubtypeCascade";

function isDeniedContext(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  return Boolean(
    value.reason ||
      value.typeName ||
      value.typePath ||
      value.cargoName ||
      value.projectName ||
      value.typeId ||
      value.settingsPath
  );
}

export function leadAccessDeniedHttpStatus(error) {
  return Number(
    error?.status ?? error?.httpStatus ?? error?.response?.status ?? 0
  );
}

/** 403 do gate de solicitação (tipo, empresa ou visibilidade do cargo). */
export function isLeadAccessDeniedStatus(error) {
  return leadAccessDeniedHttpStatus(error) === 403;
}

export function parseLeadAccessDeniedPayload(error) {
  const body = normalizeApiErrorBody(error);
  const candidates = [
    error?.data,
    body?.data,
    body,
    error,
    error?.response?.data?.data,
    error?.response?.data,
  ];
  for (const candidate of candidates) {
    if (isDeniedContext(candidate)) return candidate;
  }
  return {
    message: error?.message || body?.message || null,
  };
}

export function mergeDeniedContext(...parts) {
  const merged = {};
  for (const part of parts) {
    if (!part || typeof part !== "object" || Array.isArray(part)) continue;
    for (const [key, value] of Object.entries(part)) {
      if (value != null && value !== "") merged[key] = value;
    }
  }
  const edit = merged.settingsEdit;
  if (edit && typeof edit === "object") {
    merged.settingsPath = buildTypePermissionSettingsPath(edit);
  } else if (!merged.settingsPath && (merged.typeId || merged.subtype1)) {
    merged.settingsPath = buildTypePermissionSettingsPath(merged);
  }
  return merged;
}
